module.exports = __webpack_public_path__ + "img/bg-compliance-2.8df9ac2d.png";